import React from 'react';
import { motion } from 'framer-motion';
import GlobalNavbar from './GlobalNavbar';
import FinalFooter from './FinalFooter';
import './Layout.css';

const pageVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut',
    },
  },
};

const Layout = ({ children }) => {
  return (
    <div className="layout-wrapper">
      <GlobalNavbar />
      <motion.main
        className="layout-content"
        variants={pageVariants}
        initial="hidden"
        animate="visible"
      >
        {children}
      </motion.main>
      <FinalFooter />
    </div>
  );
};

export default Layout;
